import { jsx as _jsx } from "react/jsx-runtime";
import { isValidGeoGridCell } from '@iotv/iotv-v3-types';
import { useContext } from 'react';
import { GridCellAreaPortalLabel } from '../../../GoogleMapV4/components/Labels/GridCellAreaPortalLabel';
import { NonLinkAreaPortalLabel } from '../../../GoogleMapV4/components/Labels/NonLinkAreaPortalLabel';
import { NetworkCoverageContext } from '../NetworkCoverageContext';
import { AreaDataPopup } from './AreaDataPopUp';
const debug = process.env.REACT_APP_DEBUG && false;
export const LabelArbitrator = ({ vob }) => {
    debug && console.log('LabelArbitrator has vob', vob);
    const { state } = useContext(NetworkCoverageContext);
    const { areaData } = state;
    const isGeoGridCell = isValidGeoGridCell(vob);
    const data = areaData.find((d) => vob.sk === d.metadata?.generatedFrom);
    // coverage report table
    if (data)
        return _jsx(AreaDataPopup, { vob: data });
    return isGeoGridCell ? _jsx(GridCellAreaPortalLabel, { vob }) : _jsx(NonLinkAreaPortalLabel, { vob });
};
